import { render, staticRenderFns } from "./CaptureList.vue?vue&type=template&id=d1267a84"
import script from "./CaptureList.vue?vue&type=script&lang=js"
export * from "./CaptureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports